'use strict';

bbw.shared.PasswordResetCtrl = ngtk.controller.Base.extend({

    $inject: ['$scope', '$q', '$timeout', 'rpcClient', 'bbw.RedirectSvc'],

    /**
     * @type {ngtk.rpcClient.Client}
     */
    _rpcClient: undefined,

    /**
     * @type {Function}
     */
    _bbwRedirectSvc: null,

    _init: function() {
        this.$scope.user = {};
        this.$scope.user_ = {};
    },

    changeAdminPassword: function(code) {
        this.changePassword(code, true);
    },

    changePassword: function(code, isAdmin) {
        delete this.$scope.user_.errors;
        this.$scope.user_.processing = true;
        this._rpcClient.post((isAdmin ? 'admin' : 'user') + '/password-reset/' + code, this.$scope.user).
            execute().
            then(function(response) {
                this.$scope.ctrlStatus.finished = true;
                response.redirect && this._bbwRedirectSvc.redirect(response.redirect);
            }.bind(this)).
            catch(function(err) {
                this.$scope.user_.errors = err;
                if (err && err.error) {
                    this.$scope.user_.error = err.error;
                }
            }.bind(this)).
            finally(function() {
                delete this.$scope.user_.processing;
            }.bind(this));
    }

});
